import type {Time} from '../../projects/index.js'

export const mapMinutesOfDay = (time: Time): number => {
  const [hour, minute] = time.split(':').map(Number)
  return hour * 60 + minute
}
